<template>
    <div>
        <b-table-simple class="bor-table text-left">
            <b-tbody>
                <b-tr>
                    <b-td> Sub Code </b-td>
                    <b-td>
                        <b-form-input v-model="sub_code" placeholder="sub code"
                            :disabled="is_saving_subs"
                            />
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td>Type</b-td>
                    <b-td>
                        <b-dropdown :text="selected_sub_type ? selected_sub_type : '질문 유형(type)을 선택해 주세요'"
                            variant="dark-border"
                            :class="[{ 'no-validated': selected_sub_type }]"
                            :disabled="is_saving_subs"
                            >
                            <b-dropdown-item-button v-for="item in sub_types"
                                :key="`subs-type-${item.id}-${item}`"
                                @click="selectType(item)"
                                >
                                {{ item }}
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <!--저장 등-->
        <b-alert class="py-2" :variant="alert_variant">
            {{ alert_msg }}
        </b-alert>
        <div class="float-right">
            <b-button @click="handleSaveSub" variant="blue"
                :disabled="is_saving_subs || is_saving_subs"
                >
                <div class="d-flex align-items-center">
                    저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                </div>
            </b-button>
            <b-button @click="$emit('click-cancel')"
                class="ml-2"
                :disabled="is_saving_subs"
                >
                취소
            </b-button>
        </div>
    </div>
</template>

<script>
import { generateSubcomponentInitData } from '@core_utils/subComponent/subComponent';

export default {
    name: 'editing-others',
    props: {
        idx: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            sub_code: '',
            alert_msg: '',
            alert_variant: 'danger',
            sub_types: ['radio', 'checkbox', 'file_URL2', 'guide_text','guide_text2', 'textbox', 'table'],
            selected_sub_type: 'radio',
            local_sub: {
                sub_description: '새 문항'
            },
            type_by_structure: {
                radio: {
                    structure:[
                        {text: '예', value: '예'},
                        {text: '아니오', value: '아니오'}
                    ],
                    result: []
                },
                checkbox: {
                    structure:[
                        {text: '예', value: '예'},
                        {text: '아니오', value: '아니오'}
                    ],
                    result: []
                },
                file_URL2: {},
                guide_text: {
                    structure: ['가이드 텍스트입니다.'],
                },
                guide_text2: {
                    structure: ['가이드 텍스트입니다.'],
                },
                textbox: {
                    structure: [],
                    result: [],
                    placeholder: null
                },
                table: {
                    // 최소 한 컬럼만. 연도 고정값은 매년 손대야 하고, 헤더를 고치면 번역 가드에 막힌다.
                    table_header: ['구분'],
                    result: [],
                    structure: [
                        { placeholder: {}, input_type: {}, noteditables: [], dropdown: {}, calculation: {} }
                    ]
                }
            },
            is_saving_subs: false
        }
    },
    computed: {},
    watch: {
        // selected_sub_type (_selected_sub_type) {
        //     if (_selected_sub_type) {
        //         this.local_sub = this.generateSubsInit()
        //     }
        // }
    },
    mounted () {
        this.local_sub = this.generateSubsInit()
    },
    methods: {
        selectType (item) {
            this.selected_sub_type = item
            this.local_sub = this.generateSubsInit()
            // this.$forceUpdate()
        },
        generateSubsInit () {
            if (this.idx < 0) {
                const _init_sub = generateSubcomponentInitData()
                if (this.selected_sub_type && this.type_by_structure[this.selected_sub_type]) {
                    _init_sub.sub_type = this.selected_sub_type
                    _init_sub.sub_data_contents = this.type_by_structure[this.selected_sub_type]
                }

                _init_sub.sub_code = this.sub_code
                _init_sub.sub_description = '새 문항'

                return _init_sub
            }

            return this.$store.state.question_subs[this.idx]
        },
        async handleSaveSub () {
            try {
                this.is_saving_subs = true
                if (!this.sub_code) { 
                    this.showAlert('danger',"질문 코드(Sub Code)를 선택해야 합니다")
                    return false
                }

                if (!this.selected_sub_type) { 
                    this.showAlert('danger',"질문 유형(type)을 선택해야 합니다")
                    return false 
                }

                this.local_sub.sub_code = this.sub_code
                
                await this.$store.dispatch('saveQuestionSub', this.local_sub)
                this.$emit('click-save')
            } catch (error) {
                alert('죄송합니다. 문항 생성 도중 장애가 발생했습니다. 개발팀에 문의해주세요.')
            } finally {
                this.is_saving_subs = false
            }
        },
        showAlert(alert_variant, msg) {
            this.alert_variant = alert_variant
            this.alert_msg = msg
            this.dismissCountDown = this.dismissSecs
        },
    }
}
</script>
<style scoped>
.no-validated{
    border-color: var(--red)
}

</style>
